export default __webpack_public_path__ + "static/media/10.60c04ad9.png";